export const DEFAULTS = {
  "validacoes.email_paciente_obrigatorio": true,
  "validacoes.email_cuidador_obrigatorio": true,
  "receptivo.origens": ["medico", "laboratorio", "paciente", "responsavel", "outro"],
  "agendamento.medico_solicitante": false,
  "agendamento.observacoes": false,
  "agendamento.local_procedimento": false,
  "agendamento.despesas": false,
  "agendamento.aceite_recusa": false,
  "agendamento.status_lista": [
    "solicitado",
    "liberado",
    "em_analise",
    "finalizado",
    "cancelado",
  ],
};

/**
 * Garante que as configurações do programa estejam em formato de objeto.
 * Aceita:
 *  - null/undefined  → retorna {}
 *  - objeto          → retorna o próprio objeto
 *  - string JSON     → faz JSON.parse e retorna o objeto (ou {} em caso de erro)
 *
 * @param {*} configuracoes - Valor vindo da API/banco (string, objeto, etc.)
 * @returns {object} Objeto de configurações normalizado
 */
export function parseProgramaConfiguracoes(configuracoes) {
  if (!configuracoes) return {};

  // Já é objeto
  if (typeof configuracoes === "object") {
    return configuracoes ?? {};
  }

  // Veio como string
  if (typeof configuracoes === "string") {
    const str = configuracoes.trim();
    if (!str) return {};

    try {
      const parsed = JSON.parse(str);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (error) {
      console.error("Falha ao interpretar configurações do programa:", error);
      return {};
    }
  }

  // Qualquer outro tipo inesperado
  return {};
}

/**
 * Busca um valor aninhado em um objeto de configuração.
 *
 * - Se o caminho não existir nas configurações do programa,
 *   tenta pegar o valor em DEFAULTS[path].
 * - Se também não existir em DEFAULTS, usa o fallback.
 *
 * @param {*} configuracoes - Objeto ou string JSON com as configurações.
 * @param {string} path - Caminho do valor (ex: "agendamento.medico_solicitante").
 * @param {*} fallback - Valor padrão final, caso não exista em cfg nem em DEFAULTS.
 * @returns {*} O valor encontrado, ou DEFAULTS[path], ou fallback.
 */
export function getConfig(configuracoes, path, fallback) {
  const cfg = parseProgramaConfiguracoes(configuracoes);
  const parts = path.split(".");
  let cur = cfg;

  for (const p of parts) {
    if (cur && typeof cur === "object" && p in cur) {
      cur = cur[p];
    } else {
      // Não encontrou no JSON: tenta nos defaults
      return Object.prototype.hasOwnProperty.call(DEFAULTS, path)
        ? DEFAULTS[path]
        : fallback;
    }
  }

  // Se encontrou o caminho mas o valor é undefined, também cai no default/fallback
  if (typeof cur === "undefined") {
    return Object.prototype.hasOwnProperty.call(DEFAULTS, path)
      ? DEFAULTS[path]
      : fallback;
  }

  return cur;
}